export default {
  'Xinjiang FTZ':{center:[85.510272, 40.84152],zoom:5},
  'Xizang FTZ':{center:[87.838564, 31.616792],zoom:5},
  'Neimenggu FTZ':{center:[111.230208, 42.013154],zoom:5},
  'Qinghai FTZ':{center:[96.069291, 36.107818],zoom:5},
  'Sichuan FTZ':{center:[102.540196, 31.166664],zoom:5},
  'Heilongjiang FTZ':{center:[126.762714, 47.108518],zoom:5},
  'Gansu FTZ':{center:[103.771112, 35.161803],zoom:6},
  'Yunnan FTZ':{center:[100.568742, 25.06511],zoom:6},
  'Guangxi FTZ':{center:[108.587878, 23.929809],zoom:6},
  'Hunan FTZ':{center:[111.709149, 27.560188],zoom:6},
  'Shanxi FTZ':{center:[107.930091, 33.404791],zoom:6},
  'Guangdong FTZ':{center:[113.487842, 24.104169],zoom:6},
  'Jilin FTZ':{center:[126.165165, 43.380602],zoom:6},
  'Hebei FTZ':{center:[115.43978, 38.568954],zoom:6},
  'Hubei FTZ':{center:[112.327646, 30.932695],zoom:6},
  'Guizhou FTZ':{center:[106.147532, 26.134304],zoom:6},
  'Shandong FTZ':{center:[118.09366, 35.947973],zoom:6},
  'Jiangxi FTZ':{center:[115.587226, 27.865172],zoom:6},
  'Henan FTZ':{center:[113.302086, 33.764935],zoom:6},
  'Liaoning FTZ':{center:[123.390106, 41.222247],zoom:6},
  'Shanxi FTZ':{center:[112.142715, 37.399174],zoom:6},
  'Anhui FTZ':{center:[117.275731, 32.448449],zoom:6},
  'Fujian FTZ':{center:[117.546963, 25.803743],zoom:6},
  'Zhejiang FTZ':{center:[119.620259, 29.284433],zoom:6},
  'Jiangsu FTZ':{center:[118.968969, 33.60216],zoom:6},
  'Chongqing FTZ':{center:[106.632809, 29.540849],zoom:6},
  'Ningxia FTZ':{center:[106.042662, 37.401799],zoom:7},
  'Hainan FTZ':{center:[109.604442, 19.164778],zoom:7},
  'Taiwan FTZ':{center:[120.87655, 23.712008],zoom:7},
  'Beijing FTZ':{center:[116.489367, 40.610029],zoom:7},
  'Tianjin FTZ':{center:[117.236835, 38.951618],zoom:7},
  'Shanghai FTZ':{center:[121.373237, 31.273094],zoom:8},
  'Xianggang FTZ':{center:[114.1666082, 22.27248321],zoom:8},
  'Aomen FTZ':{center:[113.538095, 22.189786],zoom:8},
}